/**
 * Romust · Guía de tallas
 * - Abre/cierra el diálogo.
 * - Calculadora: con la medida del pie en cm recomienda la talla (la primera con cm >= medida).
 * - "Elegir": selecciona esa talla en el selector de variantes de Horizon y cierra la guía.
 * - Recordar talla: la guarda en localStorage y la preselecciona al entrar a un producto.
 */
(() => {
  if (customElements.get('romust-tallas')) return;

  const STORAGE_KEY = 'romust:talla';

  const storage = {
    get() {
      try {
        return localStorage.getItem(STORAGE_KEY);
      } catch (e) {
        return null;
      }
    },
    set(value) {
      try {
        localStorage.setItem(STORAGE_KEY, value);
      } catch (e) {
        /* modo privado: no pasa nada */
      }
    },
  };

  class RomustTallas extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.optionName = (this.dataset.optionName || 'Talla').toLowerCase();
      this.rows = [...this.querySelectorAll('tr[data-size]')];
      this.result = this.querySelector('[data-result]');
      this.rememberCheck = this.querySelector('[data-remember-check]');

      this.querySelector('[data-open]').addEventListener('click', () => this.open());
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.dialog.close();
      });

      this.querySelector('[data-cm-input]').addEventListener('input', (e) => this.recommend(e.target.value));

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-pick]');
        if (btn) this.pick(btn.dataset.pick);
      });

      if (this.dataset.remember === 'true') this.preselectSaved();
    }

    open() {
      this.markRow(this.currentSize());
      this.dialog.showModal();
    }

    /** Inputs de la opción de talla en el selector de variantes de la página. */
    sizeInputs() {
      const scope = this.closest('product-information, .product-information, main') || document;
      return [...scope.querySelectorAll('input[type="radio"][data-option-name]')].filter(
        (input) => input.dataset.optionName.toLowerCase() === this.optionName
      );
    }

    currentSize() {
      const checked = this.sizeInputs().find((input) => input.checked);
      return checked ? checked.value : null;
    }

    markRow(size) {
      this.rows.forEach((row) => row.classList.toggle('is-current', row.dataset.size === size));
    }

    recommend(raw) {
      const cm = parseFloat(String(raw).replace(',', '.'));
      this.rows.forEach((row) => row.classList.remove('is-recommended'));
      if (!cm || cm < 20 || cm > 32) {
        this.result.innerHTML = '';
        return;
      }
      const row = this.rows.find((r) => parseFloat(r.dataset.cm) >= cm) || null;
      if (!row) {
        this.result.textContent = 'Tu medida es mayor que nuestra talla más grande. Escríbenos y te asesoramos.';
        return;
      }
      row.classList.add('is-recommended');
      const size = row.dataset.size;
      const canPick = row.querySelector('[data-pick]');
      this.result.innerHTML = canPick
        ? `Tu talla es la <strong>${size}</strong>. <button type="button" class="romust-tallas__pick romust-tallas__pick--solid" data-pick="${size}">Elegir talla ${size}</button>`
        : `Tu talla es la <strong>${size}</strong>, pero no está disponible en este modelo.`;
    }

    pick(size, { close = true, save = true } = {}) {
      const input = this.sizeInputs().find((i) => i.value === size);
      if (!input) return false;
      if (!input.checked) input.click();
      this.markRow(size);
      if (save && (!this.rememberCheck || this.rememberCheck.checked)) storage.set(size);
      if (close && this.dialog.open) this.dialog.close();
      return true;
    }

    preselectSaved() {
      const saved = storage.get();
      // Si el cliente llegó con una variante en la URL (anuncio, enlace a un color), no la cambiamos.
      if (!saved || new URL(window.location.href).searchParams.has('variant')) return;
      const input = this.sizeInputs().find((i) => i.value === saved);
      if (!input || input.checked || input.getAttribute('aria-disabled') === 'true') return;
      this.pick(saved, { close: false, save: false });
    }
  }

  customElements.define('romust-tallas', RomustTallas);
})();
